import React from "react";
import PropTypes from "prop-types";
import { Type } from "discover.medical.react-component-library";
import { ErrorContainer } from "./styled";

const DrugInteractionsError = ({ viewModel }) => (
  <ErrorContainer>
    <Type element="h4" fontWeight="bold" marginBottom="md">
      {viewModel.name}
    </Type>
    <Type element="p">{viewModel.message}</Type>
  </ErrorContainer>
);

DrugInteractionsError.displayName = "DrugInteractionResultsError";
DrugInteractionsError.propTypes = {
  viewModel: PropTypes.shape({
    name: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
  }).isRequired,
};

export default DrugInteractionsError;
